module.exports = __webpack_public_path__ + "static/media/indyasterisk.3406a49f.png";